/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import dayjs from "dayjs";
import { valorAPesos } from "utils/formatters";
import {
    ESTADO_PAGO_PAGADO,
    ESTADO_PAGO_PENDIENTE_COBRO,
    getPagoEstadoVisible,
} from "../utils/pagoLoteDisplay";

const columns = [
    { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
    { name: "id", desc: "ID", align: "left", noOrder: true },
    { name: "descripcion", desc: "Descripción", align: "left", noOrder: true },
    { name: "createdAt", desc: "Fecha realizado", align: "left", noOrder: true },
    { name: "estado", desc: "Estado", align: "left", noOrder: true },
    { name: "total", desc: "Total", align: "left", noOrder: true },
    { name: "accion", desc: "", align: "left", noOrder: true },
];

const columnsCC1 = [
    { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
    { name: "id", desc: "ID", align: "left", noOrder: true },
    { name: "descripcion", desc: "Descripción", align: "left", noOrder: true },
    { name: "createdAt", desc: "Fecha realizado", align: "left", noOrder: true },
    { name: "estado", desc: "Estado", align: "left", noOrder: true },
    { name: "total", desc: "Total", align: "left", noOrder: true }
];

const getRows = (data, handleOpenMenu) => {
    const rows = [];
    if (data && data.length > 0) {
        data.forEach((item) => {
            const estado = item?.tipo === "PagoCuentaCorriente" ? getPagoEstadoVisible(item) : item?.estado;
            rows.push({
                type: (
                    <SoftBox display="flex" flexDirection="row" onClick={(e) => handleOpenMenu(e, item)}>
                        {item?.tipo === 'CuentaCorriente' && (
                            <Tooltip title="Cuenta corriente" placement="top">
                                <Icon fontSize="small" color="error">
                                    attach_money
                                </Icon>
                            </Tooltip>
                        )}
                        {item?.tipo === 'PagoCuentaCorriente' && (
                            <Tooltip title="Pago cuenta corriente" placement="top">
                                <Icon fontSize="small" color="green">
                                    money_off
                                </Icon>
                            </Tooltip>
                        )}
                    </SoftBox>
                ),
                id: (
                    <SoftBox onClick={(e) => handleOpenMenu(e, item)}>
                        <SoftTypography
                            verticalAlign="text-top"
                            variant="caption"
                            color="dark"
                            fontWeight="bold"
                        >
                            {item?.id}
                        </SoftTypography>
                    </SoftBox>
                ),
                descripcion: (
                    <SoftBox onClick={(e) => handleOpenMenu(e, item)}>
                        <SoftTypography verticalAlign="text-top" variant="caption">
                            {item?.descripcion ? item?.descripcion : "Sin especificar"}
                        </SoftTypography>
                    </SoftBox>
                ),
                createdAt: (
                    <SoftBox onClick={(e) => handleOpenMenu(e, item)}>
                        <SoftTypography verticalAlign="text-top" variant="caption">
                            {item?.createdAt ? dayjs(item?.createdAt).format("DD-MM-YYYY") : ""}
                        </SoftTypography>
                    </SoftBox>
                ),
                estado: (
                    <SoftBadge
                        variant="gradient"
                        badgeContent={estado ? estado : "N/A"}
                        color={
                            estado === ""
                                ? "light"
                                : estado === "Pendiente" || estado === ESTADO_PAGO_PENDIENTE_COBRO
                                    ? "warning"
                                    : estado === "Aprobado" || estado === ESTADO_PAGO_PAGADO
                                        ? "success"
                                        : estado === "Rechazado"
                                            ? "error"
                                            : "light"
                        }
                        size="xs"
                        container
                    />
                ),
                total: (
                    <SoftBox onClick={(e) => handleOpenMenu(e, item)}>
                        <SoftTypography
                            verticalAlign="text-top"
                            variant="caption"
                            color={
                                item?.tipo === "CuentaCorriente"
                                    ? "error"
                                    : item?.tipo === "PagoCuentaCorriente"
                                        ? "uproGreen"
                                        : "secondary"
                            }
                            fontWeight="medium"
                        >
                            {item?.total ? valorAPesos(item?.total) : ""}
                        </SoftTypography>
                    </SoftBox>
                ),
                accion: (
                    <SoftBox
                        mr={2}
                        sx={{
                            cursor: "pointer",
                        }}
                        onClick={(e) => handleOpenMenu(e, item)}
                    >
                        <Tooltip title="Opciones" placement="top">
                            <Icon
                                sx={{ color: "primary", cursor: "pointer", mx: 0.5 }}
                                fontSize="small"
                                onClick={(e) => handleOpenMenu(e, item)}
                            >
                                more_vert
                            </Icon>
                        </Tooltip>
                    </SoftBox>
                )
            });
        });
    }

    return rows;
}

export default { columns, columnsCC1, getRows };